import React from "react";
import { CurrentDateDisplayProps } from "./CurentDateDisplayTypes";
import getCurrentDate from "./CurrentDateDisplayUtils";
import { getTextColor } from "../charts/utils";
import "./CurrentDateDisplay.scss";

export default function CurrentDateDisplay(props: CurrentDateDisplayProps) {
  return (
    <div
      className="current-date-display-component"
      style={{ color: getTextColor(props.theme) }}
    >
      {getCurrentDate(props.year, props.month, props.day)}
    </div>
  );
}
